import {axios, HOST, config} from './settiing';

export default {
  getConfigVal() {
    return axios.get(`${HOST}/resource/configure`, config)
  },
}